import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const VN_TZ = 'Asia/Ho_Chi_Minh';

/**
 * Driving.dob trong DB hiện có 3 format sống chung:
 *   - "20031102"                 (XML import cũ)
 *   - "2003-11-02"               (form edit — input type="date")
 *   - "2003-11-01T17:00:00.000Z" (StudentImportModal cũ — đã ghi ISO,
 *     parse phải qua VN+07 mới ra đúng wall-clock 2003-11-02)
 *
 * Mọi UI đọc dob phải đi qua các helper dưới đây thay vì `new Date(raw)`
 * thuần hoặc `dayjs(raw)` không TZ (sẽ lệch 1 ngày cho format thứ 3).
 */

export function parseDob(raw) {
  if (raw == null || raw === '') return null;
  if (raw instanceof Date) {
    const d = dayjs(raw).tz(VN_TZ);
    return d.isValid() ? d : null;
  }
  if (typeof raw !== 'string') return null;
  const s = raw.trim();
  if (!s) return null;

  if (/[TZ]/.test(s)) {
    const d = dayjs.utc(s).tz(VN_TZ);
    return d.isValid() ? d : null;
  }
  if (/^\d{8}$/.test(s)) {
    const d = dayjs(s, 'YYYYMMDD', true);
    return d.isValid() ? d : null;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const d = dayjs(s, 'YYYY-MM-DD', true);
    return d.isValid() ? d : null;
  }
  const formats = ['DD/MM/YYYY', 'D/M/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD'];
  for (const fmt of formats) {
    const d = dayjs(s, fmt, true);
    if (d.isValid()) return d;
  }
  const fb = dayjs(s);
  return fb.isValid() ? fb : null;
}

/** `YYYY-MM-DD` cho `<input type="date">`. Trả `''` nếu invalid. */
export function formatDobYmd(raw) {
  const d = parseDob(raw);
  return d ? d.format('YYYY-MM-DD') : '';
}

/** `DD/MM/YYYY` để hiển thị. Trả `''` nếu invalid. */
export function formatDobDisplay(raw) {
  const d = parseDob(raw);
  return d ? d.format('DD/MM/YYYY') : '';
}
